import { mapRangeVariantToDateRange } from './ComplexStaticDateRangePicker.service';
import { ALL_DEFAULT_RANGES_KEYS, DEFAULT_RANGES_LABELS_MAP, } from './ComplexStaticDateRangePicker.constants';
export const useDefaultRanges = () => {
    return ALL_DEFAULT_RANGES_KEYS.map((rangeVariant) => ({
        type: rangeVariant,
        label: DEFAULT_RANGES_LABELS_MAP[rangeVariant],
        getValue: () => mapRangeVariantToDateRange(rangeVariant),
    }));
};
//# sourceMappingURL=ComplexStaticDateRangePicker.hooks.js.map